<template>
  <div>
    <Navigation showPromoterNav="true"></Navigation>
  </div>
</template>


<script>
import Navigation from '../Admin/Navigation/Navigation';

export default {
  name: 'AdminDashboard',
  components: {
    Navigation,
  },
  data() {
    return {
    };
  },
  computed: {

  },
  watch: {

  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// AdminDashboard.vue?3e303c9c